import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss', '/src/assets/css/common-v2/main-custom.scss']
})
export class BreadcrumbComponent {
  @Input() breadcrumbs: [];

  constructor(
    private router: Router
  ) { }

  isCurrentRoute(route: string): boolean {
    return this.router.url.includes(route);
  }
}
